import React from 'react';
import { getSearchResult } from '../actions/searchAction';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';
import moment from 'moment';

const phoneTypeOptions = [
    { label: 'Pre-sales', value: 'Pre-sales' },
    { label: 'Post-sales', value: 'Post-sales' }
]

const dateToday = moment().format('YYYY-MM-DD');

// const hourOptions = [ "10", "11", "12", "13", "14", "15", "16", "17", "18", "19" ];

// const minuteOptions = [ "00", "30" ];

class SendMessageForm extends Component {

    constructor() {
        super();
        this.myRef = React.createRef();
        this.state = {
            messageData: {},
            audienceList: [],
            scheduleMessageNow: 1,
            timeOptions: []
        };
    }

    componentWillReceiveProps({ audienceList }) {
        this.setState({ audienceList })
    }

    componentWillMount() {
        this.props.fetchAudienceList();
        let timeOptions = [];
        let startTime = moment(`${dateToday} 10:00`).valueOf();
        const endTime = moment(`${dateToday} 20:00`).valueOf();
        while(startTime <= endTime) {
            timeOptions.push({ label: moment(startTime).format("hh:mm a"), value: moment(startTime).format("HH:mm") });
            startTime += 1800 * 1000;
        }
        console.log("timeOptions", timeOptions);
        this.setState({ timeOptions: timeOptions })
    }

    MessageInput = ({ label, name, type, required = true, inputParams = {} }) => {
        return (
            <div className="col-12 col-md-2 addVendorInput">
                <div className="form-group">
                    <div className="mb-3">
                        <label>{`${label} ${required ? '*' : ''}`}</label>
                        <input className="form-control customInput" type={type} name={name} placeholder={label} onChange={(e) => this.handleMessageInputChange(e)} {...inputParams} required={required} step={1800} />
                    </div>
                </div>
            </div>
        )
    }

    MessageInputTestSend = ({ label, name, type, required = true, inputParams = {} }) => {
        return (
            <div className="col-12 col-md-4 addVendorInput">
                <div className="form-group">
                    <label>{`${label} ${required ? '*' : ''}`}</label>
                    <div className="input-group mb-3">
                        <select className="form-control customInput" name={name} placeholder={label} onChange={(e) => this.handleMessageInputChange(e)} {...inputParams} required={required}>
                            <option value="">Select Phone Number</option>
                            <option value="7840058645">7840058645</option>
                            <option value="9962987122">9962987122</option>
                            <option value="7827969886">7827969886</option>
                            <option value="9205893368">9205893368</option>
                        </select>
                        <div class="input-group-append">
                            <button class="btn btn-outline-success" type="button" onClick={this.handleSendTestMessage}>Test Send</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    MessageCheckbox = ({ label, name }) => {
        return (
            <div className="col-12 addVendorInput col-md-1">
                <div className="form-group">
                    <div className="mb-3 mt-3">
                        <label>&nbsp;</label>
                        <input className="form-check-input customInput" type="checkbox" onChange={(e) => this.handleMessageInputChange(e)} name={name} />
                        <label className="form-check-label">
                            {label}
                        </label>
                    </div>
                </div>
            </div>
        )
    }

    MessageTextArea = ({ label, name, type, required = true, inputParams = {} }) => {
        return (
            <div className="col-12 col-md-4 addVendorInput">
                <div className="form-group">
                    <div className="mb-3">
                        <label>{`${label} ${required ? '*' : ''}`}</label>
                        <textarea className="form-control customInput" type={type} name={name} placeholder={label} onChange={(e) => this.handleMessageInputChange(e)} {...inputParams} required={required} rows="5" />
                    </div>
                </div>
            </div>
        )
    }

    MessageInputFile = ({ label, name, required = true, inputParams = {} }) => {
        return (
            <div className="col-12 col-md-2 addVendorInput">
                <div className="form-group">
                    <div className="mb-3">
                        <label>{`${label} ${required ? '*' : ''}`}</label>
                        <input className="form-control customInput" type={"file"} name={name} placeholder={label} onChange={(e) => this.handleMessageInputFileChange(e)} {...inputParams} required={required} />
                    </div>
                </div>
            </div>
        )
    }

    MessageSelect = ({ label, name, options = [], required = false }) => {
        return (
            <div className="col-12 col-md-2 addVendorInput">
                <div className="form-group">
                    <div className="mb-3">
                        <label>{`${label} ${required ? '*' : ''}`}</label>
                        <Select
                            isSearchable={true}
                            placeholder={label}
                            name={name}
                            options={options}
                            onChange={(e) => this.handleMessageSelectChange(e, name)}
                            isMulti={false}
                        />
                    </div>
                </div>
            </div>
        )
    }

    handleMessageInputChange = (e) => {
        let { name, value } = e.target;
        let { messageData = {} } = this.state;
        messageData[name] = value;
        console.log("handleMessageInputChange", name, value);
        this.setState({
            messageData
        })
    }

    handleCheckboxChange = (e) => {
        let { name, value, checked } = e.target;
        this.setState({ scheduleMessageNow: checked ? 1 : 0 })
        console.log("handleCheckboxChange", name, value, checked);
    }

    handleMessageInputFileChange = (e) => {
        let { name } = e.target;
        let file = e.target.files[0];
        console.log(name, file);
        let { messageData = {} } = this.state;
        messageData[name] = file;
        this.setState({
            messageData
        })
    }

    handleMessageSelectChange = (e, name) => {
        console.log(e, name);
        let value = e.value;
        let { messageData = {} } = this.state;
        messageData[name] = value;
        this.setState({
            messageData
        })
    }

    handleSubmitForm = (e) => {
        e.preventDefault();
        let { messageData = {} } = this.state;
        console.log("Submit", messageData);
        this.props.sendMessageWhatsapp({ ...messageData, scheduleMessageNow: this.state.scheduleMessageNow });
    }

    handleSendTestMessage = (e) => {
        e.preventDefault();
        let { messageData = {} } = this.state;
        this.props.testSendMessage(messageData);
    }

    render() {

        let { MessageInput, handleSubmitForm, MessageSelect, MessageInputFile, MessageTextArea, MessageCheckbox, MessageInputTestSend } = this;

        let { messageData = {}, audienceList = [] } = this.state;

        console.log(messageData);
        return (
            <div className="procurementAddVendor">
                <h4 className="procurementAddVendorHeading">Send Message</h4>
                <form onSubmit={handleSubmitForm} ref={this.myRef}>
                    <div style={{ marginLeft: '40px' }}>
                    <p>Please note</p>
                    <ul>
                        <li>For the pre-sales audience, the message will be sent via one-on-one chat.</li>
                        <li>For the post-sales audience, the message will be sent in the group chat if the group exists; otherwise, it will be sent as a one-on-one message.</li>
                    </ul>
                    </div>
                    <div className="addVendorForm">
                        <div className="row">
                            <MessageSelect
                                isMulti={false}
                                label="Audience type"
                                name="phoneType"
                                required={true}
                                options={phoneTypeOptions}
                            />
                            <MessageSelect
                                isMulti={false}
                                label="Audience"
                                name="audience"
                                required={true}
                                options={messageData.phoneType && audienceList.length ? audienceList.filter(row => row.audienceType == messageData.phoneType).map(row => ({ label: row.audienceName, value: row.id })) : []}
                            />
                            <MessageInputFile
                                label="File"
                                name="file"
                                required={false}
                            />
                        </div>
                        <div className="row">
                            <MessageTextArea
                                label="Message"
                                name="message"
                                type="textarea"
                                required={true}
                            />
                        </div>
                        <div className="row">
                            <MessageInputTestSend
                                label="10 Digit Mobile Number"
                                name="testPhone"
                                type="number"
                                required={false}
                            />
                        </div>
                        {/* <div className="row">
                            <div className="col-2"><b>Schedule Now</b></div>
                            <div className="col-8">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="true" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                        <div className="col-12"><b>or</b></div>
                        </div> */}
                        <div>
                            {/* <p><b>Schedule Now</b></p> */}
                            {/* <MessageInput
                                label="Scheduled Time"
                                name="scheduledTime"
                                type="datetime-local"
                                required={true}
                            /> */}
                            <div className="col-4 addVendorInput">
                                <div className="form-group">
                                    <div className="mb-3">
                                        <label style={{ display: "flex", alignItems: "center", gap: "5px"  }}>
                                            <span>Schedule Now</span>
                                            <input type="checkbox" checked={this.state.scheduleMessageNow} onChange={this.handleCheckboxChange} name="scheduleMessageNow" />
                                            <div>or enter schedule time</div>
                                        </label>
                                        <div className="row">
                                            <input className="form-control customInput col-6" type="date" name="scheduledDate" onChange={(e) => this.handleMessageInputChange(e)} disabled = {this.state.scheduleMessageNow} min={dateToday} />

                                            { !this.state.scheduleMessageNow ? <div className="col-6">
                                                <div className="form-group">
                                                    <div className="mb-3">
                                                        <Select
                                                            isSearchable={true}
                                                            placeholder={"Time"}
                                                            name={"scheduledTime"}
                                                            options={this.state.timeOptions}
                                                            onChange={(e) => this.handleMessageSelectChange(e, "scheduledTime")}
                                                            isMulti={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div> : "" }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-outline-success" style={{ float: 'right' }}>Submit</button>
                        <div style={{ clear: 'both' }}></div>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SendMessageForm);